export default __webpack_public_path__ + "static/media/avatar.4a000e6c.svg";